import { CSSProperties } from 'react';
import classNames from 'classnames';
import { useSpring, animated } from 'react-spring';
import { SIZE_OFFSET, TourStep } from './TourStep';
import { TourItem } from './index';

export enum OverlayPosition {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

const getOverlayPositionStyles = (
  rect: DOMRect | null,
  position: OverlayPosition,
): CSSProperties => {
  if (!rect) return {};

  switch (position) {
    case OverlayPosition.Left:
      const width = rect.left - SIZE_OFFSET / 2;
      return {
        right: rect.left,
        left: 0,
        width: width > 0 ? width : 0,
        height: '100%',
        backgroundColor: 'red',
      };
    case OverlayPosition.Top:
      return {
        top: 0,
        height: rect.top - SIZE_OFFSET / 2,
        left: rect.left - SIZE_OFFSET / 2,
        width: rect.width + SIZE_OFFSET,
        backgroundColor: 'green',
      };
    case OverlayPosition.Bottom:
      return {
        left: rect?.x - SIZE_OFFSET / 2,
        top: rect?.bottom + SIZE_OFFSET / 2,
        width: rect?.width + SIZE_OFFSET,
        bottom: 0,
        backgroundColor: 'blue',
      };
    case OverlayPosition.Right:
      return {
        backgroundColor: 'pink',
        height: '100%',
        left: rect.right + SIZE_OFFSET / 2,
        right: 0,
      };
    default:
      return {};
  }
};

export const backgroundColor = '!bg-gray-200/50';

export function WrapperOverlay({
  rect,
  position,
}: {
  rect: DOMRect | null;
  position: OverlayPosition;
}) {
  return (
    <div
      className={classNames(
        'absolute pointer-events-auto',
        rect ? backgroundColor : 'bg-gray-50',
      )}
      id={`overlay-${position}`}
      style={getOverlayPositionStyles(rect, position)}
    />
  );
}

export function TourStepWrapper({
  tourStep,
  rect,
  stepIndex,
  ...props
}: {
  tourStep: TourItem;
  component: HTMLElement | null;
  rect: DOMRect | null;
  stepIndex: number;
  stepCompleted: boolean;
}) {
  const styles = useSpring({
    from: { opacity: props.stepCompleted ? 0 : 1 },
    to: {
      opacity: props.stepCompleted ? 0 : 1,
    },
  });

  return (
    <animated.div
      className="h-full w-full relative pointer-events-none"
      style={styles}
    >
      {!!rect && !props.stepCompleted && (
        <div className="z-10">
          <TourStep
            {...tourStep}
            stepIndex={stepIndex}
            component={props.component}
          />
        </div>
      )}
      <div className="h-full w-full relative z-0">
        <WrapperOverlay rect={rect} position={OverlayPosition.Top} />
        <WrapperOverlay rect={rect} position={OverlayPosition.Left} />
        <WrapperOverlay rect={rect} position={OverlayPosition.Right} />
        <WrapperOverlay rect={rect} position={OverlayPosition.Bottom} />
      </div>
    </animated.div>
  );
}
